// ABOUTME: Builds custom list definitions for the applicant Agenda schedule modal.
// ABOUTME: Keeps modal lists stable when candidate data is still partial.
export const buildJobListDefinition = (
    jobs: Compleo.IObject[] | undefined
): Compleo.CustomLists.ListDefinitionType => ({
    data: (Array.isArray(jobs) ? jobs : []).map((item: any) => {
        return {
            JobId: item.JobId,
            JobTitle: item.JobTitle
        };
    }),
    fieldName: "job",
    labelName: "JobTitle",
    valueName: "JobId"
});

interface IBuildRecipientListDefinition {
    applicantEmail?: string;
    t: (key: string) => string;
    userList: Compleo.IObject[];
}

export const buildRecipientListDefinition = ({
    applicantEmail,
    t,
    userList
}: IBuildRecipientListDefinition): Compleo.CustomLists.ListDefinitionType => {
    const usersData = userList.map((item: any) => {
        return {
            value: item.itemValue,
            label: `${item.itemText} - ${item.itemValue}`
        };
    });
    const applicantRecipientLabel = applicantEmail
        ? `${t("applicantRecipient")} - ${applicantEmail}`
        : t("applicantRecipient");

    return {
        data: [
            {
                value: "applicant",
                label: applicantRecipientLabel
            },
            ...usersData
        ],
        fieldName: "recipients",
        labelName: "label",
        valueName: "value"
    };
};
